import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "search-result",
  class: "flex-container-col text-left"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "redText"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { style: {"text-decoration":"underline"} }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_button_header = _resolveComponent("close-button-header")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_close_button_header, {
      background: "",
      onClose: _ctx.onClose
    }, null, 8, ["onClose"]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.localize('searchResults')) + " (" + _toDisplayString(_ctx.searchResultCount) + ")", 1),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loader_guard, {
        hasLoaded: !_ctx.state.isUpdating
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.result.groups, (matchGroup) => {
            return (_openBlock(), _createBlock(_component_card, {
              key: matchGroup.title
            }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack section" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card_title, { class: "text-cutoff" }, {
                      default: _withCtx(() => [
                        (matchGroup.directMatch)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "#",
                              onClick: _withModifiers(($event: any) => (_ctx.gotoSearchResult(matchGroup.directMatch)), ["prevent"])
                            }, _toDisplayString(matchGroup.title), 9, _hoisted_2))
                          : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(matchGroup.title), 1))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    (matchGroup.partMatches.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.localize('isPartOf')) + ":", 1),
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matchGroup.partMatches, (partMatch) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: partMatch.partOf.id,
                                class: "text-cutoff"
                              }, [
                                _createElementVNode("a", {
                                  class: "text-cutoff",
                                  href: "#",
                                  onClick: _withModifiers(($event: any) => (_ctx.gotoSearchResult(partMatch.match)), ["prevent"])
                                }, _toDisplayString(partMatch.partOf.materialNo) + " " + _toDisplayString(partMatch.partOf.description), 9, _hoisted_6)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, " - "))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["hasLoaded"])
    ])
  ], 64))
}